import styled from 'styled-components/macro'
import { Button as btn } from 'reactstrap'
import { theme } from 'styled-tools'
import { media } from '../../../ui/rwd'
import { MdShare as mdShare } from 'react-icons/md'

const ButtonShare = styled(btn)`
  display: none !important;
  margin-right: 1rem;
  position: relative;
  padding-left: 4rem !important;
  padding-right: 4rem !important;
  ${media.sm`
    display: inline-block !important;
  `};
  color: ${theme('productPlusButtonIcon', 'black')} !important;
  background: ${theme('productPlusButtonBackground', 'black')} !important;
`
const ShareIcon = styled(mdShare)`
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
`

export { ButtonShare, ShareIcon }
